export default {
  title: {
    id: 'gift_card_message_title',
    defaultMessage: 'Add a gift message',
  },
  subtitle: {
    id: 'gift_card_message_subtitle',
    defaultMessage: 'Something sweet to add to their email.',
  },
  recipientInputLabel: {
    id: 'gift_card_message_recipient_input_label',
    defaultMessage: "Recipient's name",
  },
  senderInputLabel: {
    id: 'gift_card_message_sender_input_label',
    defaultMessage: "Sender's name",
  },
  messageInputLabel: {
    id: 'gift_card_message_message_input_label',
    defaultMessage: 'Gift message',
  },
  messageInputLabelInfo: {
    id: 'gift_card_message_message_input_label_info',
    defaultMessage:
      'Enter a message {characterLimit} characters or less (optional)',
  },
}
